import { Provider } from 'mobx-react';
import * as React from 'react';
import Router from './modules/router';
import RootStore from './stores/rootStore';
import utils from './modules/utils';
function Loader() {
  const [showLoader, setShowLoader] = React.useState(false);

  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowLoader(true);
    }, 300);
    return () => window.clearTimeout(timer);
  })

  
  return (
    <div className='App'>
      <div className='loader__wrap'>
        {showLoader ? 
        <div className='lds-ring'><div/><div/><div/><div/></div>
        : 
        <></>}
      </div>
    </div>
  )
}
const rootStore = new RootStore();

function App() {
  React.useEffect(() => {
    if (utils.isCommontownApp()) {
      location.href = 'ptapp://system/ready';
    }
  },[]);

  return (
    <React.Suspense fallback={<Loader />}>
      <Provider rootStore={rootStore}>
        <Router/>
      </Provider>
    </React.Suspense>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx